import React, { useEffect, useState } from "react";

import { Box, FormHelperText, Grid, Stack } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "reactstrap";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import CustomButton from "../../components/Form/CustomButton";
import { Icon } from "@iconify/react/dist/iconify.js";
import CustomTextField from "../../components/Form/CustomTextField";
import CustomSelect from "../../components/Form/CustomSelect";
import FormEditors from "../Forms/FormEditors";
import UploadProductImagesNew from "../../components/Form/UploadProductImagesNew";
import CustomIconButton from "../../components/Form/CustomIconButton";
import CheckBox from "../../components/Form/CheckBox";
import CustomSelectMultiple from "../../components/Form/CustomSelectMultiple";
import { getAccessoryDetails, resetAccessoryActionState, updateAccessory } from "../../store/actions";
import TableStyle2 from "../../components/Common/TableStyle2";

const EditAccessory = ({ leftSideBarType, layoutWidth, accessoryDetails, brandList, categoryList, makeList, modelList, accessoryEdit, salesmanList, locationList, accessoryDetailsCode }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { ID } = useParams();

    const [formObj, setFormObj] = useState({});
    const [selectedRow, setSelectedRow] = useState();
    const [newSalesman, setNewSalesman] = useState([]);
    const [addNewModel, setAddNewModel] = React.useState(false);
    const [newModel, setNewModel] = React.useState({ make: '', model: '' });
    const [editRow, setEditRow] = React.useState();
    const [error, setError] = React.useState();

    const compatibleList = [
        { label: 'Fits all motocycles', value: 'fit_all' },
        { label: 'By make / model', value: 'by_make_model' },
    ]
    const [loading, setIsLoading] = useState(false);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    const removeThousandsSeparator = (value) => {
        if (value === null || value === undefined) return '';
        return String(value).replace(/,/g, '');
    };

    const handleRemoveSalesman = (index) => {
        let temp = [...formObj?.salesmans];
        temp.splice(index, 1);
        handleFormObjChange('salesmans', temp);
        setSelectedRow(null);
    }

    useEffect(() => {
        if (accessoryDetailsCode?.code && accessoryDetailsCode?.code !== 'success') {
            setIsLoading(false);
        }
    }, [accessoryDetailsCode]);

    const header = [
        {
            title: 'Name',
            accessor: (item, idx) => {
                const isEdit = selectedRow?.idx === idx ? true : false;
                return (
                    <>
                        {
                            isEdit ?
                                <CustomSelect
                                    values={selectedRow?.salesman_id || '-1'}
                                    onChange={(e) => setSelectedRow({ ...selectedRow, salesman_id: e, contact: salesmanList.find((salesman) => salesman.id === e)?.phone || '', salesman_name: salesmanList.find((salesman) => salesman.id === e)?.name || '', location_id: salesmanList.find((salesman) => salesman.id === e)?.branch_id || '', location_name: salesmanList.find((salesman) => salesman.id === e)?.branch_name || '' })}
                                    placeholder={'Salesman'}
                                    data={(salesmanList || []).filter(salesman =>
                                        selectedRow?.salesman_id === salesman.id || // Include the currently selected salesman
                                        (!newSalesman.some(newSm => newSm.salesman_id === salesman.id) &&
                                            !formObj?.salesmans?.some(existingSm => existingSm.salesman_id === salesman.id))
                                    ) || []}
                                    labelName={'name'}
                                    valueName={'id'}
                                    height={30}
                                    marginTop="7px"
                                    padding={"0px"}
                                />
                                : item?.salesman_name ? item.salesman_name : salesmanList.find((salesman) => salesman.id === item?.salesman_id)?.name || '-'
                        }
                    </>
                )
            }
        },
        {
            title: 'Branch',
            accessor: (item, idx) => {
                const isEdit = selectedRow?.idx === idx ? true : false;
                return (
                    <>
                        {
                            isEdit ?
                                <CustomSelect
                                    values={selectedRow?.location_id || '-1'}
                                    onChange={(e) => setSelectedRow({ ...selectedRow, location_id: e, location_name: locationList.find((location) => location.id === e)?.branch_name || '' })}
                                    data={locationList || []}
                                    labelName={'branch_name'}
                                    valueName={'id'}
                                    placeholder={'Branch'}
                                    height={30}
                                    marginTop="7px"
                                    padding={"0px"}
                                />
                                : item?.location_name || '-'
                        }
                    </>
                )
            }
        },
        {
            title: 'Contact',
            accessor: (item, idx) => {
                const isEdit = selectedRow?.idx === idx ? true : false;
                return (
                    <>
                        {
                            isEdit ?
                                selectedRow?.contact
                                : item?.contact || '-'
                        }
                    </>
                )
            }
        },
        {
            title: 'Action',
            accessor: (item, idx) => {
                const isEdit = selectedRow?.idx === idx ? true : false;
                return (
                    <div className="d-flex flex-direction-row">
                        <div
                            style={{ color: isEdit ? '#B48A3C' : '#1D1B1B', cursor: 'pointer', textDecoration: isEdit ? 'underline' : 'none' }}
                            onClick={() => isEdit ? handleEditSalesman(item, idx) : setSelectedRow({ ...item, idx })}
                        >
                            {isEdit ? 'Save' : 'Edit'}
                        </div>
                        <>
                            {isEdit &&
                                selectedRow?.temp_id === item?.temp_id &&
                                <div className="mx-3 clickable" onClick={() => handleRemoveSalesman(idx)} style={{ color: '#D13536' }}>Remove</div>
                            }
                        </>
                    </div>

                )
            }
        },
    ];

    const inputListing = [
        {
            name: 'salesman_id',
            inputType: 'select',
            placeholder: 'Salesman',
            data: (salesmanList || []).filter(salesman =>
                // !newSalesman.some(newSm => newSm.salesman_id === salesman.id) &&
                !formObj?.salesmans?.some(existingSm => existingSm.salesman_id === salesman.id)
            ),
        },
        {
            name: 'location_id',
            inputType: 'select',
            placeholder: 'Branch',
            data: locationList || [],
            labelName: 'branch_name',
            valueName: 'id',
        },
        {
            name: 'contact',
            view: true,
        },
        {
            name: 'action',
            actionName: 'Save',
            removeAction: true,
            actionOnClick: (e) => { handleSaveNewSalesman(e) }
        }
    ]

    useEffect(() => {
        if (ID) {
            dispatch(getAccessoryDetails({ id: ID }));
        }
    }, [ID])

    useEffect(() => {
        if (accessoryEdit?.code === 'success') {
            error && setError(null);
            setNotification({ open: true, msg: accessoryEdit?.message || 'Update successful', type: 'success' });
            dispatch(resetAccessoryActionState());
            dispatch(getAccessoryDetails({ id: ID }));
        } else if (accessoryEdit?.code === 'invalid_field' || accessoryEdit?.code === 'error') {
            setError(accessoryEdit?.errors);
            setNotification({ open: true, msg: accessoryEdit?.message || 'Invalid field', type: 'error' });
            setIsLoading(false);
            dispatch(resetAccessoryActionState());
        }
    }, [accessoryEdit])

    useEffect(() => {
        if (accessoryDetails?.id) {
            setFormObj({
                id: accessoryDetails?.id,
                name: accessoryDetails?.name || '',
                brand_id: accessoryDetails?.brand_id || '',
                category_id: accessoryDetails?.category_id || '',
                sub_category_id: accessoryDetails?.sub_category_id || '',
                is_compatible_all: accessoryDetails?.is_compatible_all ? 0 : 1,
                compatible: accessoryDetails?.is_compatible_all === 1 ? 'fit_all' : 'by_make_model',
                make_model: accessoryDetails?.compatibles?.length > 0 ? accessoryDetails?.compatibles?.map((item) => ({ id: item.id, make: item.bike_make_id, model: item.bike_models?.map((z, idx) => z?.bike_model_id), is_apply_all: item.is_apply_all })) : null,
                bike_make_id: accessoryDetails?.bike_make_id || '',
                is_apply_all: accessoryDetails?.is_apply_all ? 0 : 1,
                bike_model_id: accessoryDetails?.bike_model_id || [],
                selling_price: removeThousandsSeparator(accessoryDetails?.selling_price) || '',
                // promotion_price: accessoryDetails?.promotion_price || '',
                salesmans: accessoryDetails?.salesmans ? accessoryDetails?.salesmans.map((item) => ({ ...item, contact: item?.phone })) : null,
                title: accessoryDetails?.info?.title || '',
                description: accessoryDetails?.info?.description || '',
                youtube_url: accessoryDetails?.info?.youtube_url || '',
                facebook_url: accessoryDetails?.info?.facebook_url || '',
                instagram_url: accessoryDetails?.info?.instagram_url || '',
                tiktok_url: accessoryDetails?.info?.tiktok_url || '',
                // thumbnail_image: accessoryDetails?.images ? accessoryDetails?.images?.filter((item) => item.type === 'thumbnail').map((item) => ({ id: item.id, file_base64: item.base64, file_name: item.name })) : [],
                // photos: accessoryDetails?.images ? accessoryDetails?.images?.map((item) => ({ id: item.id, file_base64: item.base64, file_name: item.name, is_thumbnail: item?.type === "thumbnail" ? 1 : 0 })) : []
            })
            let data = accessoryDetails?.images ? accessoryDetails?.images?.map((item) => ({ id: item.id, file_base64: item.base64, file_name: item.name, is_thumbnail: item?.type === "thumbnail" ? 1 : 0 })) : []
            // data?.push({ id: -1, file_base64: accessoryDetails?.thumbnail_base64, file_name: accessoryDetails?.thumbnail_name, is_thumbnail: 1 })
            setFormObj((prev) => ({ ...prev, photos: data }))
            setIsLoading(false);
        }
    }, [accessoryDetails])

    const handleFormObjChange = (key, value) => {
        let tempObj = { ...formObj };
        tempObj[key] = value;
        setFormObj(tempObj);
    }

    const handleSaveNewModel = () => {
        handleFormObjChange('make_model', [...formObj?.make_model || [], newModel]);
        setAddNewModel(false);
        setNewModel({ make: '', model: '' })
    }

    const handleSaveEditModel = () => {
        let tempArr = formObj?.make_model || [];
        const index = tempArr.findIndex(item => item.make === editRow.make);
        if (index !== -1) {
            tempArr[index] = editRow;
        }
        handleFormObjChange('make_model', tempArr);
        setEditRow(null);
    }

    const handleDeleteModel = (index) => {
        let tempArr = formObj?.make_model || [];
        tempArr.splice(index, 1);
        handleFormObjChange('make_model', tempArr);
    }

    const handleSaveNewSalesman = (salesman) => {
        let temp = Array.isArray(formObj?.salesmans) ? [...formObj?.salesmans] : [];
        temp.push({ ...salesman, temp_id: `edit-${(formObj?.salesmans?.length + 1) || 1}` });
        handleFormObjChange('salesmans', temp);
        //remove from newSalesman
        let updatedNewSalesman = [...newSalesman];
        updatedNewSalesman = updatedNewSalesman.filter((item) => item !== salesman);
        setNewSalesman(updatedNewSalesman);
    }

    const handleEditSalesman = (salesman, index) => {
        let temp = [...formObj?.salesmans];
        temp[index] = { ...selectedRow };
        handleFormObjChange('salesmans', temp);
        setSelectedRow(null);
    }

    const handleSubmit = () => {
        setIsLoading(true);
        let payload = {
            name: formObj?.name,
            brand_id: formObj?.brand_id,
            category_id: formObj?.category_id,
            sub_category_id: formObj?.sub_category_id,
            is_compatible_all: formObj?.compatible === 'fit_all' ? 1 : 0,
            selling_price: removeThousandsSeparator(formObj?.selling_price),
            // promotion_price: formObj?.promotion_price,
            title: formObj?.title,
            description: formObj?.description,
            youtube_url: formObj?.youtube_url,
            facebook_url: formObj?.facebook_url,
            instagram_url: formObj?.instagram_url,
            tiktok_url: formObj?.tiktok_url,
            images: [],
            salesmans: formObj?.salesmans?.map((item) => ({ salesman_id: item?.salesman_id, location_id: item?.location_id })) || [],
        }
        if (formObj?.compatible === 'by_make_model') {
            payload.compatibilities = formObj?.make_model ? formObj?.make_model?.map((item) => ({ bike_make_id: item.make, bike_model_ids: item.is_apply_all ? [] : item.model, is_apply_all: item.is_apply_all ? 1 : 0 })) : [];
        }

        payload.thumbnail = formObj?.photos?.filter((item) => item.is_thumbnail)?.[0]?.file_base64 || '';
        payload.thumbnail_name = formObj?.photos?.filter((item) => item.is_thumbnail)?.[0]?.file_name || '';

        if (formObj?.photos && formObj?.photos.length > 0) {
            formObj?.photos?.map((img) => {
                payload.images.push({
                    id: img?.id || null,
                    is_thumbnail: img?.is_thumbnail ? 1 : 0,
                    name: img?.file_name,
                    file: img?.file_base64,
                })
            })
        }
        dispatch(updateAccessory({ id: ID, data: payload }));
    }

    const accessoryInfoForm = () => {
        const filterModelList = newModel?.make ? makeList.find((model) => model.id === newModel?.make)?.models : modelList;
        return (
            <div id="accessory-info-section">
                <Box>
                    <div className="text-semibold">About</div>
                    <Grid container spacing={2}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <CustomTextField
                                title={'Accessory name'}
                                placeholder={'Accessory name'}
                                values={formObj?.name || ''}
                                onChange={(e) => handleFormObjChange('name', e)}
                                error={error?.name}
                            />
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <CustomSelect
                                title={'Brand'}
                                placeholder={'Brand'}
                                values={formObj?.brand_id || ''}
                                onChange={(e) => handleFormObjChange('brand_id', e)}
                                data={brandList || []}
                                labelName={'name'}
                                valueName={'id'}
                                error={error?.brand_id}
                            />
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <CustomSelect
                                title={'Category'}
                                placeholder={'Category'}
                                values={formObj?.category_id || ''}
                                onChange={(e) => handleFormObjChange('category_id', e)}
                                data={categoryList || []}
                                labelName={'name'}
                                valueName={'id'}
                                error={error?.category_id}
                            />
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <CustomSelect
                                title={'Sub-category'}
                                placeholder={'Sub-category'}
                                values={formObj?.sub_category_id || ''}
                                onChange={(e) => handleFormObjChange('sub_category_id', e)}
                                data={formObj?.category_id ? categoryList?.find((item) => item.id === formObj?.category_id)?.sub_categories || [] : []}
                                labelName={'name'}
                                valueName={'id'}
                                error={error?.sub_category_id}
                            />
                        </Grid>
                    </Grid>
                </Box>
                <Box mt={4}>
                    <div className="text-semibold">Compatible Models</div>
                    <Stack sx={{ flexDirection: 'row', gap: 2, mt: 2, flexWrap: 'wrap' }}>
                        {compatibleList.map((item, index) => (
                            <div className={formObj?.compatible === item.value ? "vehicle-small-button-selected" : "vehicle-small-button"} onClick={() => handleFormObjChange('compatible', item.value)}>
                                {item.label}
                            </div>
                        ))}
                    </Stack>
                </Box>
                {
                    formObj?.compatible === 'by_make_model' &&
                    <Box mt={4}>
                        <Grid container spacing={2}>
                            <Grid item sm={6}>
                                <div className="text-semibold">Select by Make / model</div>
                            </Grid>
                            <Grid item sm={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end', sm: 'end' } }}>
                                <CustomButton
                                    title={'Add make / model'}
                                    press={() => setAddNewModel(true)}
                                />
                            </Grid>
                            {error?.compatibilities && formObj?.compatible === "by_make_model" && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.compatibilities && formObj?.compatible === "by_make_model" ? "Please select compatible models" : ""}</FormHelperText>}

                            {
                                addNewModel &&
                                <Grid item sm={12}>
                                    <div className="dashboard-card">
                                        <div className="text-semibold">Make</div>
                                        <CustomSelect
                                            title={'Make'}
                                            placeholder={'Make'}
                                            values={newModel?.make || '-1'}
                                            data={makeList || []}
                                            labelName={'name'}
                                            valueName={'id'}
                                            onChange={(e) => setNewModel({ ...newModel, make: e })}
                                        />
                                        {
                                            !newModel?.is_apply_all &&
                                            <>
                                                <div className="text-semibold mt-2">Model</div>
                                                <CustomSelectMultiple
                                                    title={"Model"}
                                                    placeholder={'Model'}
                                                    values={newModel?.model || []}
                                                    onChange={(e) => {
                                                        const allModels = newModel?.make
                                                            ? makeList?.find(item => item.id === newModel?.make)?.models?.map(model => model.id) || []
                                                            : modelList?.map(model => model.id) || [];
                                                        const selectedModels = e;
                                                        const isApplyAll = allModels.length > 0 && allModels.every(model => selectedModels.includes(model));

                                                        setNewModel({ ...newModel, model: selectedModels, is_apply_all: isApplyAll });
                                                    }}
                                                    data={filterModelList || []}
                                                    labelName={'name'}
                                                    valueName={'id'}
                                                />
                                            </>
                                        }
                                        <div className="mt-2">
                                            <CheckBox
                                                label={'Applies to all models under selected make'}
                                                values={newModel?.is_apply_all}
                                                onChange={(e) => setNewModel({ ...newModel, is_apply_all: e.target.checked, model: e.target.checked ? makeList?.find(item => item.id === newModel?.make)?.models?.map(model => model.id) || [] : [] })}
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <CustomButton
                                                title={'Cancel'}
                                                press={() => { setAddNewModel(false); setNewModel({ make: '', model: '' }) }}
                                                backgroundColor={'#F9F9F9'}
                                                textColor={'#808588'}
                                                borderStyle={'1px solid #F9F9F9'}
                                                width={'50%'}
                                                padding={20}
                                            />
                                            <CustomButton
                                                title={'Save'}
                                                press={() => { handleSaveNewModel(); }}
                                                width={'50%'}
                                                padding={20}
                                                marginLeft={10}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                            }
                            {
                                editRow &&
                                <Grid item sm={12}>
                                    <div className="dashboard-card">
                                        <div className="text-semibold">Make</div>
                                        <CustomSelect
                                            title={'Make'}
                                            placeholder={'Make'}
                                            values={editRow?.make || '-1'}
                                            data={makeList || []}
                                            labelName={'name'}
                                            valueName={'id'}
                                            onChange={(e) => setEditRow({ ...editRow, make: e })}
                                        />
                                        {
                                            !editRow?.is_apply_all &&
                                            <>
                                                <div className="text-semibold mt-2">Model</div>
                                                <CustomSelectMultiple
                                                    title={"Model"}
                                                    placeholder={'Model'}
                                                    values={editRow?.model || []}
                                                    onChange={(e) => {
                                                        const allModels = editRow?.make
                                                            ? makeList?.find(item => item.id === editRow?.make)?.models?.map(model => model.id) || []
                                                            : modelList?.map(model => model.id) || [];
                                                        const selectedModels = e;
                                                        const isApplyAll = allModels.length > 0 && allModels.every(model => selectedModels.includes(model));

                                                        setEditRow({ ...editRow, model: selectedModels, is_apply_all: isApplyAll });
                                                    }}
                                                    data={editRow?.make ? makeList.find((model) => model.id === editRow?.make)?.models : modelList || []}
                                                    labelName={'name'}
                                                    valueName={'id'}
                                                />
                                            </>
                                        }
                                        <div className="mt-2">
                                            <CheckBox
                                                label={'Applies to all models under selected make'}
                                                values={editRow?.is_apply_all}
                                                onChange={(e) => setEditRow({ ...editRow, is_apply_all: e.target.checked, model: e.target.checked ? makeList?.find(item => item.id === editRow?.make)?.models?.map(model => model.id) || [] : [] })}
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <CustomButton
                                                title={'Cancel'}
                                                press={() => { setEditRow(null) }}
                                                backgroundColor={'#F9F9F9'}
                                                textColor={'#808588'}
                                                borderStyle={'1px solid #F9F9F9'}
                                                width={'50%'}
                                                padding={20}
                                            />
                                            <CustomButton
                                                title={'Save'}
                                                press={() => { handleSaveEditModel(); }}
                                                width={'50%'}
                                                padding={20}
                                                marginLeft={10}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                            }
                            <Grid item sm={12}>
                                {
                                    formObj?.make_model?.length > 0 ? formObj?.make_model.map((item, index) => (
                                        <div key={index} className="dashboard-card" style={{ marginBottom: index === formObj?.make_model?.length - 1 ? 0 : 15 }}>
                                            <Grid container spacing={2}>
                                                <Grid item lg={9} md={9} sm={9} xs={12}>
                                                    <div style={{ fontWeight: 700 }}>{item?.make ? makeList?.find((make) => make.id === item?.make)?.name : '-'}</div>
                                                    <div className="d-flex align-items-center">
                                                        <div className="subheader-2">Selected Models: </div>
                                                        <div className="text-semibold mx-2">{item?.is_apply_all || item?.is_apply_all === 1 ? 'All' : item?.model ? item?.model?.length > 0 && item?.model?.map((x) => modelList?.find((model) => model.id === x)?.name).join(", ") : '-'}</div>
                                                    </div>
                                                </Grid>
                                                <Grid item lg={3} md={3} sm={3} xs={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end', sm: 'end', xs: 'start' } }}>
                                                    <CustomIconButton
                                                        iconName={'ri:pencil-line'}
                                                        onClick={() => setEditRow(item)}
                                                    />
                                                    <CustomIconButton
                                                        iconName={'ri:delete-bin-line'}
                                                        color={'#D13536'}
                                                        onClick={() => handleDeleteModel(index)}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                    )) :
                                        <div className="d-flex align-items-center justify-content-center" style={{ backgroundColor: '#F9F9F9', color: '#BDBDBD', border: '1px dashed #D9D9D9', height: 151, width: '100%', borderRadius: 8 }}>
                                            <div className="text-center">
                                                <Icon icon={'ri:file-paper-line'} style={{ fontSize: 24 }} />
                                                <div>No added make or model yet. </div>
                                            </div>

                                        </div>
                                }
                            </Grid>
                        </Grid>
                    </Box>
                }
                <Box mt={4}>
                    <div className="text-semibold">Pricing</div>
                    <Grid container spacing={2}>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomTextField
                                title={'Selling price'}
                                placeholder={'Selling price'}
                                values={formObj?.selling_price || ''}
                                onChange={(e) => handleFormObjChange('selling_price', e)}
                                type={'number'}
                                InputProps={{ startAdornment: '$' }}
                                error={error?.selling_price?.[0]}
                            />
                        </Grid>
                        {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomTextField
                                title={'Promotion price'}
                                isOptional={true}
                                placeholder={'Promotion price'}
                                values={formObj?.promotion_price}
                                onChange={(e) => handleFormObjChange('promotion_price', e)}
                                type={'number'}
                                InputProps={{ startAdornment: '$' }}
                                error={error?.promotion_price?.[0]}
                            />
                        </Grid> */}
                    </Grid>
                </Box>
            </div>
        )
    }

    const advertDetailsForm = () => {
        return (
            <div id="ad-details-section">
                <Box mt={4}>
                    <div className="text-semibold">Listing Title</div>
                    <Grid container spacing={1}>
                        <Grid item sm={12} xs={12}>
                            <CustomTextField
                                title={'Listing Title'}
                                placeholder={'Listing Title'}
                                values={formObj?.title || ''}
                                onChange={(e) => handleFormObjChange('title', e)}
                                error={error?.title}
                            />
                        </Grid>
                    </Grid>
                </Box>
                <Box mt={4}>
                    <div className="text-semibold mb-2">Listing Description</div>
                    <Grid container spacing={2}>
                        <Grid item sm={12} xs={12}>
                            <FormEditors
                                value={formObj?.description || ''}
                                setValue={(e) => handleFormObjChange('description', e)}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </div>
        )
    }

    const salesmanForm = () => {
        return (
            <div id="salesman-section">
                <Box mt={4} >
                    <Grid container spacing={1}>
                        <Grid item container sm={12} className="d-flex align-items-center mb-2">
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <div className="text-semibold">Salesman</div>
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                                <CustomButton
                                    title={'Add Salesman'}
                                    press={() => setNewSalesman([...newSalesman, { salesman_id: '', location_id: '', contact: '' }])}
                                />
                            </Grid>
                        </Grid>
                        <Grid item sm={12} xs={12}>
                            <TableStyle2
                                header={header}
                                tableData={formObj?.salesmans || []}
                                inputListing={inputListing}
                                setInput={setNewSalesman}
                                inputArr={newSalesman}
                                inputActionButton={(e) => (
                                    <div className="clickable text-underline" onClick={() => { handleSaveNewSalesman(e) }}>Save</div>
                                )}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </div>
        )
    }

    const handleSetThumbnail = (file, index) => {
        const updatedPhotos = (formObj?.photos || []).map((photo, photoIndex) => ({
            ...photo,
            is_thumbnail: file?.is_thumbnail ? false : photoIndex === index,
        }));

        if (!updatedPhotos[index]) {
            return;
        }

        handleFormObjChange('photos', updatedPhotos);
    };


    const mediaForm = () => {
        return (
            <div id="media-section">
                {/* <Box mt={2}>
                    <div className="text-semibold">Thumbnail Image</div>
                    <UploadProductImagesNew
                        showLimit={false}
                        displayFiles={false}
                        values={formObj?.thumbnail_image}
                        setFormValues={(e) => handleFormObjChange('thumbnail_image', e)}
                        maxFile={1}
                        maxFileSize={10}
                        multiple={true}
                        setNotification={setNotification}
                        images={true}
                        windowWidth={layoutWidth}
                    />
                </Box> */}
                <Box mt={2}>
                    <div className="text-semibold">Upload Photos</div>
                    <div className="subheader-2">Up to 10 images of your motorcycle’s photos</div>
                    <UploadProductImagesNew
                        showLimit={false}
                        displayFiles={false}
                        values={formObj?.photos}
                        setFormValues={(e) => handleFormObjChange('photos', e)}
                        maxFile={10}
                        maxFileSize={10}
                        md={3}
                        sm={6}
                        xs={12}
                        multiple={true}
                        setNotification={setNotification}
                        images={true}
                        windowWidth={layoutWidth}
                        handleThumbnail={handleSetThumbnail}
                    />
                    {error?.images && error?.images && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.images?.length > 0 ? error?.images?.map((item, index) => <div key={index}> {item} &nbsp;</div>) : null}</FormHelperText>}

                </Box>
                <Box mt={2}>
                    <div className="text-semibold">Video URLs <span className="optional-label me-2">Optional</span></div>
                    <CustomTextField
                        title={'Youtube'}
                        placeholder={'Youtube Url'}
                        values={formObj?.youtube_url}
                        onChange={(e) => handleFormObjChange('youtube_url', e)}
                    />
                    <div className="mt-2">
                        <CustomTextField
                            title={'Facebook'}
                            placeholder={'Facebook Url'}
                            values={formObj?.facebook_url}
                            onChange={(e) => handleFormObjChange('facebook_url', e)}
                        />
                    </div>
                    <div className="mt-2">
                        <CustomTextField
                            title={'Instagram'}
                            placeholder={'Instagram Url'}
                            values={formObj?.instagram_url}
                            onChange={(e) => handleFormObjChange('instagram_url', e)}
                        />
                    </div>
                    <div className="mt-2">
                        <CustomTextField
                            title={'TikTok'}
                            placeholder={'TikTok Url'}
                            values={formObj?.tiktok_url}
                            onChange={(e) => handleFormObjChange('tiktok_url', e)}
                        />
                    </div>
                </Box>
            </div>
        )
    }

    return (
        <React.Fragment>
            <div className="page-content" style={{ marginTop: layoutWidth <= 768 && leftSideBarType === 'condensed' ? 72 : 0 }}>
                <LoadingDialog open={loading } />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} errors={error} />
                    {accessoryDetailsCode?.code && accessoryDetailsCode?.code !== "success" ?
                        <div className="d-flex align-items-center justify-content-center" style={{ height: '70vh' }}>
                            <div className="text-center">
                                <div className="header-2 pb-3">{accessoryDetailsCode?.message || "Something went wrong."}</div>
                                <CustomButton
                                    title={'Go to Accessories'}
                                    press={() => navigate('/accessories')}
                                    padding={20}
                                />
                            </div>
                        </div> :
                        <>
                            <Grid container spacing={2} px={1} pt={2} style={{ position: 'fixed', backgroundColor: 'white', zIndex: 9, marginTop: -25 }}>
                                <Grid item sm={12}>
                                    <CustomButton
                                        title={
                                            <div className="d-flex align-items-center" style={{ fontWeight: 400 }}>
                                                <Icon icon={'fluent:chevron-left-20-regular'} style={{ marginRight: 10 }} />Back to details
                                            </div>
                                        }
                                        borderRadius={"5px"}
                                        borderStyle={"0px"}
                                        backgroundColor={"transparent"}
                                        textColor={"#000000"}
                                        paddingInline={7}
                                        press={() => navigate('/accessories/' + ID)}
                                    />
                                </Grid>
                                <Grid item xs={12} pr={0} mr={0}>
                                    <div className="px-2">
                                        <Grid container spacing={2}>
                                            <Grid item lg={7} md={12} sm={12}>
                                                <div className="header">
                                                    {formObj?.title || '-'}
                                                </div>
                                            </Grid>
                                            {
                                                layoutWidth > 768 &&
                                                <Grid item lg={5} md={12} sm={12} display={'flex'} alignItems={'center'} >
                                                    {/* <Stack sx={{ flexDirection: { lg: 'row', md: 'block' }, justifyContent: { lg: 'end', md: 'start' }, gap: 2 }}> */}
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: { lg: 'flex-end', md: 'start' } }}>
                                                        <CustomButton
                                                            title={'Cancel'}
                                                            backgroundColor="#F9F9F9"
                                                            textColor="#808588"
                                                            borderStyle="1px solid #F9F9F9"
                                                            press={() => { navigate(-1) }}
                                                        />
                                                        <CustomButton
                                                            title={'Publish changes'}
                                                            press={() => { handleSubmit(); }}
                                                            marginLeft={10}
                                                        />
                                                    </Box>

                                                    {/* </Stack> */}

                                                </Grid>
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                            <div id="content-container" style={{ paddingTop: layoutWidth <= 425 ? 130 : 150 }}>
                                <Grid container spacing={2} px={3}>
                                    <Grid item xs={12}>
                                        {accessoryInfoForm()}
                                    </Grid>
                                    <Grid item xs={12}>
                                        {advertDetailsForm()}
                                    </Grid>
                                    <Grid item xs={12}>
                                        {salesmanForm()}
                                    </Grid>
                                    <Grid item xs={12}>
                                        {mediaForm()}
                                    </Grid>
                                </Grid>
                            </div>
                        </>}
                </Container>
                {accessoryDetailsCode?.code && accessoryDetailsCode?.code !== "success" ? "" :
                    layoutWidth <= 768 &&
                    <div className="mobile-button-container d-flex justify-content-between">
                        <CustomButton
                            title={'Cancel'}
                            backgroundColor="#F9F9F9"
                            textColor="#808588"
                            borderStyle="1px solid #F9F9F9"
                            press={() => { navigate('/accessories') }}
                        />
                        <CustomButton
                            title={'Publish changes'}
                            press={() => { handleSubmit(); }}
                            marginLeft={10}
                        />
                    </div>
                }
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Login, Layout, Accessory, General }) {
    const currentStateId = Login?.verifyAdmin?.user?.data?.profile?.state_id;
    const filteredBranchList = General?.states?.find((state) => state.id === currentStateId)?.cities || [];
    return {
        userData: Login?.verifyAdmin?.user?.data,
        userPermission: Login?.permissionArry,
        leftSideBarType: Layout.leftSideBarType,
        layoutWidth: Layout.currentWidth,
        accessoryDetails: Accessory?.accessoryDetails?.data,
        accessoryDetailsCode: Accessory?.accessoryDetails,
        accessoryEdit: Accessory?.accessoryEdit,
        brandList: General.brand,
        categoryList: General.category,
        makeList: General.bike_makes,
        modelList: General.bike_models,
        salesmanList: General.dealer_salesmans,
        locationList: General?.dealer_branches || [],
    };
}


export default connect(mapStateToProps)(EditAccessory);
